var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content", attrs: { id: "AddIntegrationItem" } },
    [
      _c(
        "div",
        { staticClass: "item" },
        [
          _c("div", { staticClass: "item-image" }, [
            _c(
              "div",
              { staticClass: "item-img" },
              [
                _vm.integrationType === "web"
                  ? _c("img", {
                      staticStyle: { height: "30px" },
                      attrs: {
                        src: "https://static.supsis.live/common/email/supsisyazisislogo.png",
                        alt: "supsis",
                      },
                    })
                  : _vm.integrationType === "whatsapp"
                  ? _c("WhatsappIcon", {
                      staticStyle: { height: "30px" },
                      attrs: { color: "#58ca63" },
                    })
                  : _vm.integrationType === "whatsapp-business-api"
                  ? _c("WhatsappBusinessIcon", {
                      staticStyle: { height: "30px" },
                      attrs: { color: "#58ca63" },
                    })
                  : _vm.integrationType === "telegram"
                  ? _c("TelegramIcon", { staticStyle: { height: "30px" } })
                  : _vm.integrationType === "telegram-qr"
                  ? _c("TelegramIcon", { staticStyle: { height: "30px" } })
                  : _vm.integrationType === "instagram"
                  ? _c("InstagramIcon", {
                      staticStyle: { height: "30px" },
                      attrs: { "special-background-mode": "" },
                    })
                  : _vm.integrationType === "messenger"
                  ? _c("MessengerIcon", {
                      staticStyle: { height: "30px" },
                      attrs: { "special-background-mode": "" },
                    })
                  : _vm.integrationType === "trendyol"
                  ? _c("TrendyolIcon", { staticStyle: { height: "30px" } })
                  : _vm.integrationType === "linkedin"
                  ? _c("LinkedinIcon", { staticStyle: { height: "30px" } })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "item-text" }, [
              _vm._v(
                "\n                " + _vm._s(_vm.itemText) + "\n            "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "item-btn" },
            [
              _vm.integrationType === "web" && !_vm.isChatWidgetInstalled()
                ? _c(
                    "button",
                    {
                      staticClass: "connect-button",
                      on: { click: _vm.emitEvent },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons md-icon",
                          staticStyle: { "font-size": "20px" },
                        },
                        [_vm._v("electrical_services")]
                      ),
                      _vm._v("\n                Connect\n            "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.integrationType === "whatsapp"
                ? _c(
                    "button",
                    {
                      staticClass: "connect-button",
                      style: {
                        color:
                          _vm.matchingStoriesCount > 0 ? "#46b451" : "#2372ea",
                      },
                      on: { click: _vm.whatsappIntegrationMsg },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons md-icon",
                          staticStyle: { "font-size": "20px" },
                        },
                        [_vm._v("electrical_services")]
                      ),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.matchingStoriesCount > 0
                              ? "Connected (" + _vm.matchingStoriesCount + ")"
                              : "Connect"
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.integrationType === "whatsapp-business-api"
                ? _c(
                    "button",
                    {
                      staticClass: "connect-button",
                      style: {
                        color:
                          _vm.apiMatchingStoriesCount > 0
                            ? "#46b451"
                            : "#2372ea",
                      },
                      on: { click: _vm.whatsappApiIntegrationMsg },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons md-icon",
                          staticStyle: { "font-size": "20px" },
                        },
                        [_vm._v("electrical_services")]
                      ),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.apiMatchingStoriesCount > 0
                              ? "Connected (" +
                                  _vm.apiMatchingStoriesCount +
                                  ")"
                              : "Connect"
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.integrationType === "instagram"
                ? _c(
                    "button",
                    {
                      staticClass: "connect-button",
                      style: {
                        color:
                          _vm.instagramMatchingStoriesCount > 0
                            ? "#46b451"
                            : "#2372ea",
                      },
                      on: { click: _vm.instagramIntegrationMsg },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons md-icon",
                          staticStyle: { "font-size": "20px" },
                        },
                        [_vm._v("electrical_services")]
                      ),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.instagramMatchingStoriesCount > 0
                              ? "Connected (" +
                                  _vm.instagramMatchingStoriesCount +
                                  ")"
                              : "Connect"
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.integrationType === "messenger"
                ? _c(
                    "button",
                    {
                      staticClass: "connect-button",
                      style: {
                        color:
                          _vm.messengerMatchingStoriesCount > 0
                            ? "#46b451"
                            : "#2372ea",
                      },
                      on: { click: _vm.messengerIntegrationMsg },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons md-icon",
                          staticStyle: { "font-size": "20px" },
                        },
                        [_vm._v("electrical_services")]
                      ),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.messengerMatchingStoriesCount > 0
                              ? "Connected (" +
                                  _vm.messengerMatchingStoriesCount +
                                  ")"
                              : "Connect"
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.integrationType === "linkedin"
                ? _c(
                    "button",
                    {
                      staticClass: "connect-button",
                      style: {
                        color:
                          _vm.linkedinMatchingStoriesCount > 0
                            ? "#46b451"
                            : "#2372ea",
                      },
                      on: { click: _vm.linkedinIntegrationMsg },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons md-icon",
                          staticStyle: { "font-size": "20px" },
                        },
                        [_vm._v("electrical_services")]
                      ),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.linkedinMatchingStoriesCount > 0
                              ? "Connected (" +
                                  _vm.linkedinMatchingStoriesCount +
                                  ")"
                              : "Connect"
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.integrationType === "telegram-qr"
                ? _c(
                    "button",
                    {
                      staticClass: "connect-button",
                      style: {
                        color:
                          _vm.telegramQrMatchingStoriesCount > 0
                            ? "#46b451"
                            : "#2372ea",
                      },
                      on: { click: _vm.telegramQRIntegrationMsg },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons md-icon",
                          staticStyle: { "font-size": "20px" },
                        },
                        [_vm._v("electrical_services")]
                      ),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.telegramQrMatchingStoriesCount > 0
                              ? "Connected (" +
                                  _vm.telegramQrMatchingStoriesCount +
                                  ")"
                              : "Connect"
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.integrationType === "trendyol"
                ? _c(
                    "button",
                    {
                      staticClass: "connect-button",
                      style: {
                        color:
                          _vm.trendyolMatchingStoriesCount > 0
                            ? "#46b451"
                            : "#2372ea",
                      },
                      on: { click: _vm.trendyolIntegrationMsg },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons md-icon",
                          staticStyle: { "font-size": "20px" },
                        },
                        [_vm._v("electrical_services")]
                      ),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.trendyolMatchingStoriesCount > 0
                              ? "Connected (" +
                                  _vm.trendyolMatchingStoriesCount +
                                  ")"
                              : "Connect"
                          ) +
                          "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.integrationType === "telegram" && !_vm.isTelegramInstalled()
                ? _c(
                    "button",
                    {
                      staticClass: "connect-button",
                      on: { click: _vm.emitEvent },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons md-icon",
                          staticStyle: { "font-size": "20px" },
                        },
                        [_vm._v("electrical_services")]
                      ),
                      _vm._v("\n                Connect\n            "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isChatWidgetInstalled() && _vm.integrationType === "web"
                ? _c(
                    "a-button",
                    {
                      attrs: { type: "danger" },
                      on: { click: _vm.removeStory },
                    },
                    [
                      _c(
                        "span",
                        [
                          _c("a-icon", {
                            staticClass: "px-1",
                            attrs: { type: "api" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(
                        _vm._s(_vm.$t("chatbotv2.uninstall")) + "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isTelegramInstalled() && _vm.integrationType === "telegram"
                ? _c(
                    "a-button",
                    {
                      attrs: { type: "danger" },
                      on: { click: _vm.removeStory },
                    },
                    [
                      _c(
                        "span",
                        [
                          _c("a-icon", {
                            staticClass: "px-1",
                            attrs: { type: "api" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(
                        _vm._s(_vm.$t("chatbotv2.uninstall")) + "\n            "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.integrationType === "whatsapp"
            ? _c("WhatsappIntegrationsModal", {
                attrs: {
                  title: _vm.$t("chatbotv2.whatsappIntegrationTitle"),
                  storyId: _vm.storyId,
                  channels: _vm.whatsappChannels,
                  modalVisable: _vm.showModal,
                },
                on: {
                  close: function ($event) {
                    _vm.showModal = false
                  },
                  submit: function ($event) {
                    _vm.showModal = false
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.integrationType === "whatsapp-business-api"
            ? _c("WhatsappIntegrationsModal", {
                attrs: {
                  title: _vm.$t("chatbotv2.whatsappApiIntegrationTitle"),
                  channels: _vm.whatsappApiChannels,
                  storyId: _vm.storyId,
                  modalVisable: _vm.showModal,
                },
                on: {
                  close: function ($event) {
                    _vm.showModal = false
                  },
                  submit: function ($event) {
                    _vm.showModal = false
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.integrationType === "instagram"
            ? _c("InstagramIntegrationsModal", {
                attrs: {
                  title: "Instagram Chatbot Entegrasyonu",
                  modalVisable: _vm.showModal,
                  storyId: _vm.storyId,
                },
                on: {
                  close: function ($event) {
                    _vm.showModal = false
                  },
                  submit: function ($event) {
                    _vm.showModal = false
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.integrationType === "messenger"
            ? _c("MessengerIntegrationsModal", {
                attrs: {
                  title: "Messenger Chatbot Entegrasyonu",
                  modalVisable: _vm.showModal,
                  storyId: _vm.storyId,
                },
                on: {
                  close: function ($event) {
                    _vm.showModal = false
                  },
                  submit: function ($event) {
                    _vm.showModal = false
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.integrationType === "trendyol"
            ? _c("TrendyolIntegrationsModal", {
                attrs: {
                  title: "Trendyol Chatbot Entegrasyonu",
                  modalVisable: _vm.showModal,
                  storyId: _vm.storyId,
                },
                on: {
                  close: function ($event) {
                    _vm.showModal = false
                  },
                  submit: function ($event) {
                    _vm.showModal = false
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.integrationType === "linkedin"
            ? _c("LinkedinIntegrationsModal", {
                attrs: {
                  title: "Linkedin Chatbot Entegrasyonu",
                  modalVisable: _vm.showModal,
                  storyId: _vm.storyId,
                },
                on: {
                  close: function ($event) {
                    _vm.showModal = false
                  },
                  submit: function ($event) {
                    _vm.showModal = false
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.integrationType === "telegram-qr"
            ? _c("TelegramQRIntegrationsModal", {
                attrs: {
                  title: "Telegram QR Chatbot Entegrasyonu",
                  modalVisable: _vm.showModal,
                  storyId: _vm.storyId,
                },
                on: {
                  close: function ($event) {
                    _vm.showModal = false
                  },
                  submit: function ($event) {
                    _vm.showModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }